module.exports = __webpack_public_path__ + "a8aaf3d7cd7759454d2128f984efd8d1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/pirate-hideaway-empty.png
// module id = 322
// module chunks = 0